import React from 'react';
import { PrimaryPanelContainer, SecondaryPanelContainer } from './components';
export const PrimaryPanel = (props) => {
    const { children, selected, disabled, radius, border, header } = props;
    return (React.createElement(PrimaryPanelContainer, { selected: selected, disabled: disabled, radius: radius, border: border },
        header && React.createElement("header", null, header),
        React.createElement("section", null, children)));
};
export const SecondaryPanel = (props) => {
    const { children, selected, disabled, radius, border, header } = props;
    return (React.createElement(SecondaryPanelContainer, { selected: selected, disabled: disabled, radius: radius, border: border },
        header && React.createElement("header", null, header),
        React.createElement("section", null, children)));
};
//# sourceMappingURL=Panel.js.map